import { render, staticRenderFns } from "./Page_Signup.vue?vue&type=template&id=5abb8b0b&scoped=true&"
import script from "./Page_Signup.vue?vue&type=script&lang=js&"
export * from "./Page_Signup.vue?vue&type=script&lang=js&"
import style0 from "./Page_Signup.vue?vue&type=style&index=0&id=5abb8b0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abb8b0b",
  null
  
)

export default component.exports